var BASWebServices;
(function (BASWebServices) {
    'use strict';
    function getInventarButton() {
        return {
            template: '<button type="button" data-ng-click=gibc.getInventarButtonClicked(soc.LANGUAGE) class="getInventarButton">Show inventory</div>'
        };
    }
    BASWebServices.getInventarButton = getInventarButton;
})(BASWebServices || (BASWebServices = {}));
//# sourceMappingURL=getInventarButton.js.map